<ion-header>
  <ion-toolbar style="padding: 10px">
    <ion-button
      (click)="editKnowledgeBaseScrapeJob()"
      [disabled]="!featureEnabled"
      color="dark"
      fill="solid"
      slot="end"
    >
      <ion-icon name="globe-outline" slot="icon-only"></ion-icon>
      <span class="icon-plus-accessory">+</span>
      <span class="text-with-left-icon hidden-sm"> Add Source </span>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-card class="outline-card" *ngIf="filteredKnowledgeBaseScrapeJobs?.length">
  <ion-list class="no-padding">
    <ion-item
      *ngFor="let job of filteredKnowledgeBaseScrapeJobs"
      [ngClass]="{
        'linear-gradient-subtle-animated': isJobSyncing(job)
      }"
    >
      <ion-label>
        <h3>
          <ion-icon
            *ngIf="job.sourceType === 'notion'"
            name="custom-notion"
            style="margin-right: 5px"
          ></ion-icon>
          <ion-icon
            *ngIf="job.sourceType === 'confluence'"
            name="custom-confluence"
            style="margin-right: 5px"
          ></ion-icon>
          <ion-icon
            *ngIf="job.sourceType === 'google-drive'"
            name="custom-google-drive"
            style="margin-right: 5px"
          ></ion-icon>
          <ion-icon
            *ngIf="job.sourceType === 'web'"
            name="globe-outline"
            style="margin-right: 5px"
          ></ion-icon>
          <ion-icon
            *ngIf="job.sourceType === 'wiki-js'"
            name="custom-wiki-js"
            style="margin-right: 5px"
          ></ion-icon>
          <ion-icon
            *ngIf="job.sourceType === 'coda'"
            name="custom-coda"
            style="margin-right: 5px"
          ></ion-icon>
          <ion-icon
            *ngIf="job.sourceType === 'sharepoint-online'"
            name="custom-microsoft-sharepoint"
            style="margin-right: 5px"
          ></ion-icon>
          <span *ngIf="job.title; else showUrl">{{ job.title }}</span>
          <ng-template #showUrl>{{ job.startUrl }}</ng-template>
        </h3>
        <div *ngIf="job.title && job.startUrl" class="subtitle-url">
          {{ job.startUrl }}
        </div>
        <p>
          {{ job.userGroups?.length ? "Restricted" : "Public" }} • 
          <span *ngIf="job.lastRunAt"
            >Last synced: {{ job.lastRunAt | date: "M/d/yyyy" }}</span
          >
          <span *ngIf="!job.lastRunAt">Not synced yet</span>
          <span *ngIf="job.sourceType !== 'web' && job.autoSyncEnabled">
            • Auto-sync enabled</span
          >
        </p>
        <div>
          <ion-badge
            color="danger"
            *ngIf="job.apifyRunStatus === 'FAILED'"
            (click)="showErrorDetails(job)"
            style="cursor: pointer"
            >Last sync failed</ion-badge
          >
          <ion-badge color="warning" *ngIf="job.apifyRunStatus === 'TIMED-OUT'"
            >Sync timed out</ion-badge
          >
        </div>
      </ion-label>
      <div slot="end" style="display: flex; align-items: center">
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="editKnowledgeBaseScrapeJob(job.id)"
        >
          Edit
        </ion-button>
        <ion-button
          (click)="runKnowledgeBaseScrapeJob(job)"
          color="dark"
          fill="clear"
          class="button-dark-border"
          [disabled]="isJobSyncing(job)"
        >
          {{ isJobSyncing(job) ? "Crawling pages..." : "Re-run sync" }}
        </ion-button>
      </div>
    </ion-item>
  </ion-list>
</ion-card>

<ion-card
  class="outline-card"
  *ngIf="!isLoading && !filteredKnowledgeBaseScrapeJobs?.length"
>
  <div class="empty-state-container" style="padding: 60px">
    <span class="placeholder-emoji">
      <ion-icon name="globe"></ion-icon>
      <ion-icon name="custom-confluence" class="placeholder-icon"></ion-icon>
      <ion-icon name="custom-notion" class="placeholder-icon"></ion-icon>
      <ion-icon name="custom-google-drive" class="placeholder-icon"></ion-icon>
      <ion-icon name="custom-coda" class="placeholder-icon"></ion-icon>
      <ion-icon
        name="custom-microsoft-sharepoint"
        class="placeholder-icon"
      ></ion-icon>
    </span>
    <h1 class="placeholder-title">Connect to a wiki, website, or document</h1>
    <p class="placeholder-subtitle">
      We'll autoamtically sync in articles and resources to be used by Unthread
      AI. Click the button above to set one up
    </p>
  </div>
</ion-card>
